// iconUtils.js
import {
  FaFilePdf,
  FaFileImage,
  FaFileAudio,
  FaFileAlt,
  FaFile,
} from "react-icons/fa";

/**
 * Returns a corresponding icon component based on the MIME content type.
 * @param {string} type - MIME type string (e.g., "application/pdf", "image/jpeg").
 * @returns {JSX.Element} Icon representing the file type.
 */
export const getIconForContentType = (type, from) => {
  //console.info("Resolving icon for content type:", type, from);
  if (!type) return <FaFile className="me-2" />;
  if (type.includes("pdf")) return <FaFilePdf className="text-danger me-2" />;
  if (type.includes("image")) return <FaFileImage className="text-primary me-2" />;
  if (type.includes("audio")) return <FaFileAudio className="text-success me-2" />;
  if (type.includes("text") || type.includes("plain"))
    return <FaFileAlt className="text-muted me-2" />;
  return <FaFile className="me-2" />;
};